import { render, staticRenderFns } from "./CorteTiendaDetailComponent.vue?vue&type=template&id=0d5caa54&"
import script from "./CorteTiendaDetailComponent.vue?vue&type=script&lang=js&"
export * from "./CorteTiendaDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports